import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AppDataService, MerchantUserService, MerchantService, ConfigService, StoreService, ProductService } from 'app/services';
import { MessageService } from 'primeng/api';
import { ByMerchantRequestDto, MerchantStatusEnum, OnboardingSliderMenu, StoreStatusEnum, XpressUserRoleEnum } from 'app/models';
import { AppComponent } from 'app/app.component';

enum ReviewMenuEnum {
    Store = 1,
    Products = 2,
    Employee = 3,
    Payment = 4,
    Submit = 5
}

@Component({
    selector: 'merchant-store-onboarding',
    templateUrl: './merchant-store-onboarding.component.html',
    styleUrls: ['./merchant-store-onboarding.component.scss',
        '../../../../styles/sidebar.scss',
        '../../../../styles/style-layout.scss',
        '../../../../styles/onboardingslidermenu.scss'
    ],
    providers: [MessageService]
})
export class MerchantStoreOnboardingComponent implements OnInit, AfterViewInit, OnDestroy {
    public isMerchant: boolean = false;
    public merchantId: number = 0;

    constructor(private messageService: MessageService, public appData: AppDataService, public app: AppComponent,
        public merchantUserService: MerchantUserService, public configService: ConfigService,
        public merchantService: MerchantService, public storeService: StoreService,
        public productService: ProductService, private router: Router) {
        const reviewMerchantId = localStorage.getItem('reviewMerchantId');
        if (reviewMerchantId) {
            this.merchantId = JSON.parse(reviewMerchantId);
        } else {
            this.merchantId = parseInt(this.appData.authData.MerchantId, 10);
        }
        this.isMerchant = this.appData.isMerchant();
    }

    public xpressUserRoleEnum = XpressUserRoleEnum;
    public storeStatusEnum = StoreStatusEnum;

    public merchanUser: any = null;
    public stores: any = null;
    public payments: any = null;
    public paymentMerchantId: number = 0;

    public loading: boolean = false;

    public merchantStatusEnum = MerchantStatusEnum;
    public activeMerchantStatus: MerchantStatusEnum = MerchantStatusEnum.StoreCreation;
    public initialMerchantStatus: MerchantStatusEnum = MerchantStatusEnum.StoreCreation;
    public onboardingSliderMenu!: OnboardingSliderMenu;

    //------------------MerchantCreateStore---------------------
    public showMerchantCreateStoreSideBar: boolean = false;
    public editSelectedStore: any;
    //-------------------------------------------------------------
    //---------------Products----------------------
    public products: any = null;
    public productsCount: number = 0;
    public productId: number = 0;
    public loadingProduct: boolean = false;
    public showMerchantProductsTable: boolean = false;
    public showMerchantDetailProductSideBar: boolean = false;
    public showMerchantApprovedRejectProductSideBar: boolean = false;
    public showMerchantEditProductSideBar: boolean = false;
    public showMerchantCreateProductSideBar: boolean = false;
    //---------------End Products----------------------
    //------------------MerchantAddPayment---------------------
    public showMerchantPaymentGrid: boolean = false;
    public showMerchantAddPaymentSideBar: boolean = false;
    //-------------------------------------------------------------
    public showMerchantEmployees: boolean = false;
    //------------------MerchantStoreDetail---------------------
    public showMerchantStoreDetailSideBar: boolean = false;
    public storeId: number = 0;
    //-------------------------------------------------------------
    //------------------MerchantAddPayment---------------------
    public showMerchantDetailPaymentSideBar: boolean = false;
    //-------------------------------------------------------------

    //-------Fields for approved--------
    public dateActivatedAt!: Date;
    public otherEmail!: string;
    //----------------------------------

    public reviewMenuEnum = ReviewMenuEnum;
    public activeReviewMenuEnum: ReviewMenuEnum = ReviewMenuEnum.Store;

    public isReview: boolean = false;

    ngOnInit(): void {
        if (this.isMerchant) {
            this.getMerchantUserAndMerchant();
        } else {
            this.getStoresByMerchant();
        }
        this.haveEmployee();
    }

    ngAfterViewInit() {
        window.setTimeout(() => {
            this.onboardingSliderMenu = new OnboardingSliderMenu('#onboarding-slider-menu', 'item-' + this.activeMerchantStatus);
        }, 1000);
    }

    ngOnDestroy() {
        localStorage.removeItem('reviewMerchantId');
    }

    public setOnboardingSliderMenu(activeMerchantStoreStatus: MerchantStatusEnum) {
        window.setTimeout(() => {
            this.onboardingSliderMenu?.setCurrent('item-' + activeMerchantStoreStatus);
        }, 600);
    }

    public clickMenuLink(activeMerchantStatus: MerchantStatusEnum) {
        const allowedMerchantStatuses: Record<number, MerchantStatusEnum[]> = {
            [MerchantStatusEnum.StoreCreation]: [
                MerchantStatusEnum.StoreCreation,
            ],
            [MerchantStatusEnum.CreatedStore]: [
                MerchantStatusEnum.StoreCreation,
                MerchantStatusEnum.CreatedStore,
            ],
            [MerchantStatusEnum.AddedProducts]: [
                MerchantStatusEnum.StoreCreation,
                MerchantStatusEnum.CreatedStore,
                MerchantStatusEnum.AddedProducts,
            ],
            [MerchantStatusEnum.AddedEmployees]: [
                MerchantStatusEnum.StoreCreation,
                MerchantStatusEnum.CreatedStore,
                MerchantStatusEnum.AddedProducts,
                MerchantStatusEnum.AddedEmployees
            ],
            [MerchantStatusEnum.AddedPayment]: [
                MerchantStatusEnum.StoreCreation,
                MerchantStatusEnum.CreatedStore,
                MerchantStatusEnum.AddedProducts,
                MerchantStatusEnum.AddedEmployees,
                MerchantStatusEnum.AddedPayment,
            ]
        };

        if (allowedMerchantStatuses.hasOwnProperty(this.merchanUser.MerchantStatus) &&
            allowedMerchantStatuses[this.merchanUser.MerchantStatus]?.includes(activeMerchantStatus)) {
            this.setOnboardingSliderMenu(activeMerchantStatus);
            this.activeMerchantStatus = activeMerchantStatus;
            if (this.activeMerchantStatus === MerchantStatusEnum.AddedEmployees) {
                this.getMerchantPayoutAccounts();
            }
        } else {
            this.messageService.add({
                severity: 'error', summary: 'Error',
                detail: 'You cannot advance to another step because you did not pass the previous one.'
            });
        }
    }

    public getStoresByMerchant() {
        const dto = {
            MerchantId: this.merchantId
        };

        this.loading = true;

        this.storeService.getStoresByMerchant(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.stores = data.Items;
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public getMerchantUserAndMerchant() {
        const dto = {
            MerchantUserId: parseInt(this.appData.authData.MerchantUserId, 10)
        };

        this.loading = true;

        this.merchantUserService.getMerchantUserAndMerchantForConfirmed(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.activeMerchantStatus = data.MerchantStatus;
                this.initialMerchantStatus = data.MerchantStatus;
                this.merchanUser = data;
                this.setOnboardingSliderMenu(this.activeMerchantStatus);
                this.getStoresByMerchant();
                if (this.activeMerchantStatus === MerchantStatusEnum.CreatedStore) {
                    //this.getProductsByMerchant(0); TODO
                }
                if (this.activeMerchantStatus === MerchantStatusEnum.AddedEmployees) {
                    this.getMerchantPayoutAccounts();
                }
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public getProductsByMerchant(skip: number) {
        const dto = {
            MerchantId: this.merchantId,
            Skip: skip
        };

        this.loadingProduct = true;

        this.productService.getProductsByMerchant(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loadingProduct = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                if (data.Items !== null) {
                    this.products = data.Items.map((x: any) => {
                        x.PublishedPrice = '₱ ' + x.PublishedPrice;
                        return x;
                    });
                }

                this.loadingProduct = false;
            })
            .catch(err => {
                this.loadingProduct = false;
                throw err;
            });
    }

    public getMerchantPayoutAccounts() {
        this.loading = true;
        const payload: ByMerchantRequestDto = {
            MerchantId: parseInt(this.appData.authData.MerchantId, 10)
        };
        this.merchantService.getMerchantPayoutAccounts(payload, this.messageService)
            .then(data => {
                if(!data?.Success || data?.Items == null){
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.payments = data?.Items;
                this.showMerchantPaymentGrid = true;
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public changeMerchantStoreStatus(merchantStoreStatusId: MerchantStatusEnum) {
        if (this.isMerchant) {
            const dto = {
                MerchantId: this.appData.authData.MerchantId,
                StatusId: merchantStoreStatusId
            };

            if(merchantStoreStatusId <= this.initialMerchantStatus){
                this.activeMerchantStatus = merchantStoreStatusId;
                this.setOnboardingSliderMenu(this.activeMerchantStatus);
                return;
            }

            if(this.activeMerchantStatus === MerchantStatusEnum.AddedProducts){
                const haveEmployee = this.haveEmployee();
                if(!haveEmployee){
                    this.messageService.add({
                        severity: 'error', summary: 'Error',
                        detail: 'You cannot advance to another step because you did not pass the previous one.'
                    });
                    return;
                }
            }

            this.loading = true;
            this.merchantService.merchantStatusChange(dto, this.messageService)
                .then(data => {
                    if (!data.Success) {
                        this.loading = false;
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        return;
                    }
                    this.getMerchantUserAndMerchant();
                })
                .catch(err => {
                    this.loading = false;
                    throw err;
                });
        }
        else {
            this.activeMerchantStatus = merchantStoreStatusId;
            if (this.activeMerchantStatus === MerchantStatusEnum.CreatedStore) {
                //this.getProductsByMerchant(0); TODO
            }
            else if (this.activeMerchantStatus === MerchantStatusEnum.AddedEmployees) {
                this.getMerchantPayoutAccounts();
            }
            this.setOnboardingSliderMenu(this.activeMerchantStatus);
        }
    }

    public confirmMerchantStoreStatus() {
        const dto = {
            MerchantId: this.merchantId,
            DateActivatedAt: this.dateActivatedAt,
            OtherEmail: this.otherEmail
        };

        this.loading = true;

        this.merchantService.approvedMerchantStoreStatus(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.router.navigate(['home-root'], { skipLocationChange: true });
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public cancel() {
        this.router.navigate(['home-root'], { skipLocationChange: true });
    }

    public changeReviewMenu(value: ReviewMenuEnum) {
        this.activeReviewMenuEnum = value;
        if (this.activeReviewMenuEnum === ReviewMenuEnum.Store) {
            this.getStoresByMerchant();
        }
        else if (this.activeReviewMenuEnum === ReviewMenuEnum.Products) {
            //this.getProductsByMerchant(0); TODO
        }
        else if (this.activeReviewMenuEnum === ReviewMenuEnum.Payment) {
            this.getMerchantPayoutAccounts();
        }
    }

    public openMerchantCreateStoreSideBar() {
        this.editSelectedStore = undefined;
        this.showMerchantCreateStoreSideBar = !this.showMerchantCreateStoreSideBar;
    }
    public openMerchantEditStoreSideBar(store: any) {
        this.editSelectedStore = Object.assign(store);
        this.showMerchantCreateStoreSideBar = !this.showMerchantCreateStoreSideBar;
    }
    changedShowMerchantCreateStoreSideBarEmit(value: any) {
        this.showMerchantCreateStoreSideBar = value;
    }

    public openMerchantAddPaymentSideBar(payment: any) {
        if (payment !== null) {
            this.paymentMerchantId = payment.MerchantId;
        }
        this.showMerchantAddPaymentSideBar = !this.showMerchantAddPaymentSideBar;
    }
    changedShowMerchantAddPaymentSideBarEmit(value: any) {
        this.showMerchantAddPaymentSideBar = value;
    }

    public openMerchantStoreDetailSideBar(storeId: number) {
        this.storeId = storeId;
        this.showMerchantStoreDetailSideBar = !this.showMerchantStoreDetailSideBar;
    }
    changedShowMerchantStoreDetailSideBarEmit(value: any) {
        this.showMerchantStoreDetailSideBar = value;
    }

    public openMerchantDetailPaymentSideBar() {
        this.showMerchantDetailPaymentSideBar = !this.showMerchantDetailPaymentSideBar;
    }
    changedShowMerchantDetailPaymentSideBarEmit(value: any) {
        this.showMerchantDetailPaymentSideBar = value;
    }

    public openMerchantDetailProductSideBar(productId: number) {
        this.productId = productId;
        this.showMerchantDetailProductSideBar = !this.showMerchantDetailProductSideBar;
    }
    changedShowMerchantDetailProductSideBarEmit(value: any) {
        this.showMerchantDetailProductSideBar = value.visible;

        if (value.needUpdateProducts) {
            this.getProductsByMerchant(0);
        }
    }

    public openMerchantApprovedRejectProductSideBar(productId: number) {
        this.productId = productId;
        this.showMerchantApprovedRejectProductSideBar = !this.showMerchantApprovedRejectProductSideBar;
    }
    changedShowMerchantApprovedRejectProductSideBarEmit(value: any) {
        this.showMerchantApprovedRejectProductSideBar = value;
    }

    public openMerchantEditProductSideBar(productId: number) {
        this.productId = productId;
        this.showMerchantEditProductSideBar = !this.showMerchantEditProductSideBar;
    }
    changedShowMerchantEditProductSideBarEmit(value: any) {
        this.showMerchantEditProductSideBar = value.visible;

        if (value.productIsEdited) {
            this.getProductsByMerchant(0);
        }
    }

    changedProductsCount(value: any) {
        this.productsCount = value;
    }

    addEmployee(event: boolean) {
        this.showMerchantEmployees = event;
    }

    haveEmployee(): boolean{
        const dto = {
            MerchantId: this.merchantId,
            GetAdmins: false,
            Skip: 0,
            SearchName: '',
            Take: 1,
            SortField: '',
            SortOrder: 1
        };
        this.merchantUserService.getMerchantUsers(dto, this.messageService).then(data => {
            if(!data){
                return;
            }
            if(data?.TotalRecords > 0){
                this.addEmployee(true);
                return true;
            }

            return false;
        }).catch(err => {
            throw err;
        });

        return false;
    }

    onBackClick(){
        switch(this.activeMerchantStatus){
            case MerchantStatusEnum.StoreCreation:
                this.clickMenuLink(MerchantStatusEnum.StoreCreation);
                break;
            case MerchantStatusEnum.CreatedStore:
                this.clickMenuLink(MerchantStatusEnum.StoreCreation);
                break;
            case MerchantStatusEnum.AddedProducts:
                this.clickMenuLink(MerchantStatusEnum.CreatedStore);
                break;
            case MerchantStatusEnum.AddedEmployees:
                this.clickMenuLink(MerchantStatusEnum.AddedProducts);
                break;
            case MerchantStatusEnum.AddedPayment:
                this.clickMenuLink(MerchantStatusEnum.AddedEmployees);
                break;
            case MerchantStatusEnum.FinalReview:
                this.clickMenuLink(MerchantStatusEnum.AddedPayment);
                break;
            default:
                throw new Error(`Unsupported status: ${this.activeMerchantStatus}`);
        }
    }

    onShowProductTable(){
        this.showMerchantProductsTable = true;
    }

    showPaymentSetup(event: any){
        this.getMerchantPayoutAccounts();
    }

    hidePaymentGridView(){
        this.showMerchantPaymentGrid = false;
    }
}
